import {
    server
} from "@/api";


export const confirmation = async (params = {}) => {
    return await server().get('api/analytics/confirmation', { params })
}

export const delivery = async (params = {}) => {
    return await server().get('api/analytics/delivery', { params })
}

export const kpis = async (params = {}) => {
    return await server().get('api/analytics/kpis', { params })
}

export const ads = async (params = {}) => {
    return await server().get('api/analytics/ads', { params })
}

export const leadsByRange = async (params = {}) => {
    return await server().get('api/analytics/leads-by-range', { params })
}


export const productPerformance = async (params = {}) => {
    return await server().get('api/analytics/product-performance', { params })
}

export const products = async (params = {}) => {
    return await server().get('api/analytics/products', { params })
}

export const productDetails = async (id, params = {}) => {
    return await server().get(`api/analytics/products/${id}`, { params })
}

export default {
    confirmation,
    delivery,
    kpis,
    products,
    productPerformance,
    productDetails,
    ads,
    leadsByRange
}